import { GenericError } from './genericError.mjs';

const UNKNOWN_ERROR_TYPE = 'UnknownError';
/**
 * Ошибка, которая является по своей сути неопределенным поведением. В продуктовом коде ее рекомендуется
 * использовать осторожно (лучше вообще не использовать), только в тех случаях, где хочется подчеркнуть,
 * что код небезопасен
 *
 * @example
 *
 * ```ts
 * // Можно использовать для обертки над сторонними сервисами, такими как GTM или Карты
 * ymaps.addEventListener('error', e => logger.error(new UnknownError({ details: e.error })));
 * ```
 *
 * @export
 * @class UnknownError
 * @extends {GenericError}
 */
class UnknownError extends GenericError {
    static is(value) {
        return GenericError.is(value) && value.type === UNKNOWN_ERROR_TYPE;
    }
    static isLike(value) {
        return GenericError.is(value) && Object.getPrototypeOf(value).constructor.name === UNKNOWN_ERROR_TYPE;
    }
    constructor({ message, domain, details }) {
        super({
            type: UNKNOWN_ERROR_TYPE,
            message,
            domain,
            details,
        });
        Object.setPrototypeOf(this, UnknownError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnknownError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { UnknownError };
//# sourceMappingURL=unknownError.mjs.map
